import React from 'react';

import { CmBox } from '@/components/uiParts';

export const LoginCard: React.FC = ({ children, ...rest }) => {
  return (
    <CmBox
      p={8}
      boxShadow="lg"
      borderRadius="sm"
      backgroundColor="whiteAlpha.900"
      {...rest}
    >
      {children}
    </CmBox>
  );
};
